// Digest: d80e213f7718d323c75b0518fd7fca0265c1b848
/* eslint-disable */
/// <reference types="vite/client.d.ts" />/* eslint-disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export type ContainerSizeSubBlockOrNull = null | ContainerSizeSubBlock;
export type AlignedRichTextSubBlockOrNull = null | AlignedRichTextSubBlock;
export type RichTextBlockOrNull = null | RichTextBlock;
export type RichTextBlock = string;
export type _SlideListOrNull = null | _SlideList;
export type ImageChooserBlockOrNull = null | ImageChooserBlock;
export type _SlideList = _Slide[];
export type CharBlockOrNull = null | CharBlock;
export type CharBlock = string;
export type EmbedBlockOrNull = null | EmbedBlock;
export type EmbedBlock = string;
export type MediaChooserBlock = (
  | {
      type: "image";
      value: ImageChooserBlock;
      id: string;
    }
  | {
      type: "video";
      value: VideoChooserBlock;
      id: string;
    }
  | {
      type: "embed";
      value: MediaEmbedBlock;
      id: string;
    }
)[];
export type URLBlockOrNull = null | URLBlock;
export type URLBlock = string;
export type TableBlockOrNull = null | TableBlock;
export type TableBlock = string;
export type LabUIToolbox = (
  | {
      type: "alignedrichtextblock";
      value: AlignedRichTextBlock;
      id: string;
    }
  | {
      type: "gallerysubblock";
      value: GallerySubBlock;
      id: string;
    }
  | {
      type: "linksubblock";
      value: LinkSubBlock;
      id: string;
    }
  | {
      type: "mediachooserblock";
      value: MediaChooserBlock;
      id: string;
    }
  | {
      type: "scrollnavmenublock";
      value: ScrollNavMenuBlock;
      id: string;
    }
  | {
      type: "scrollnavmenuitemblock";
      value: ScrollNavMenuItemBlock;
      id: string;
    }
  | {
      type: "socialmediaicon";
      value: SocialMediaIcon;
      id: string;
    }
  | {
      type: "spacerblock";
      value: SpacerBlock;
      id: string;
    }
  | {
      type: "tableincontainerblock";
      value: TableInContainerBlock;
      id: string;
    }
  | {
      type: "onetrustprivacynoticeblock";
      value: OneTrustPrivacyNoticeBlock;
      id: string;
    }
  | {
      type: "videochooserblock";
      value: VideoChooserBlock;
      id: string;
    }
)[];
export type CollectionNameStylesSubBlockOrNull = null | CollectionNameStylesSubBlock;
export type TsicommonCmsRichNavigationLinkListOrNull = null | TsicommonCms;
export type TsicommonCmsPromoPeriodOrNull = null | TsicommonCms2;
export type TsicommonCmsLinkOrNull = null | TsicommonCms3;
export type FlairSubBlockOrNull = null | FlairSubBlock;
export type _PromoBubbleOrNull = null | _PromoBubble;
export type ProductChooserSubBlockOrNull = null | ProductChooserSubBlock;
export type ProductChooserSubBlock = number;
export type RichNavigationLinkTypes = (
  | {
      type: "rich_nav_general_link";
      value: _RichNavigation__GeneralLink;
      id: string;
    }
  | {
      type: "rich_nav_offer_link";
      value: _RichNavigation__OfferLink;
      id: string;
    }
  | {
      type: "rich_nav_product_link";
      value: _RichNavigation__ProductLink;
      id: string;
    }
  | {
      type: "rich_nav_dynamic_product_link";
      value: _RichNavigation__DynamicProductLink;
      id: string;
    }
  | {
      type: "rich_nav_image_link";
      value: _RichNavigation__ImageLink;
      id: string;
    }
  | {
      type: "rich_nav_button_link";
      value: _RichNavigation__ButtonLink;
      id: string;
    }
  | {
      type: "rich_nav_banner_link";
      value: _RichNavigation__BannerLink;
      id: string;
    }
)[];
export type TsicommonCms = TsicommonCms1[];
export type RichNavigationPromoFeaturesAssemblyOrNull = null | RichNavigationPromoFeaturesAssembly;
export type RichNavigationPromoFeaturesAssembly = {
  type: "image_promo";
  value: RichNavigationImagePromo;
  id: string;
}[];
export type RichNavigationContentAssembly = (
  | {
      type: "rich_nav_link_collection";
      value: RichNavigationLinkCollection;
      id: string;
    }
  | {
      type: "link";
      value: TsicommonCms3;
      id: string;
    }
  | {
      type: "closest_store_selection";
      value: CurrentStoreSection;
      id: string;
    }
)[];
export type ResponsiveVisibilitySubBlockOrNull = null | ResponsiveVisibilitySubBlock;
export type SpacingSubBlockOrNull = null | SpacingSubBlock;
export type BackgroundStylesSubBlockOrNull = null | BackgroundStylesSubBlock;
export type BackgroundImageShiftSubBlockOrNull = null | BackgroundImageShiftSubBlock;
export type IntegerBlockOrNull = null | IntegerBlock;
export type IntegerBlock = number;
export type RichNavigationBannerContentAssembly = {
  type: "banner";
  value: BannerBlock;
  id: string;
}[];
export type FreightDeliverySteps = (
  | {
      type: "order_confirmed";
      value: OrderConfirmed;
      id: string;
    }
  | {
      type: "order_processing";
      value: OrderProcessing;
      id: string;
    }
  | {
      type: "order_prepared_for_shipment";
      value: OrderPreparedForShipment;
      id: string;
    }
  | {
      type: "order_shipped";
      value: OrderShipped;
      id: string;
    }
  | {
      type: "ready_for_delivery";
      value: ReadyForDelivery;
      id: string;
    }
  | {
      type: "delivery_scheduled";
      value: DeliveryScheduled;
      id: string;
    }
  | {
      type: "out_for_delivery";
      value: OutForDelivery;
      id: string;
    }
  | {
      type: "Delivered";
      value: Delivered;
      id: string;
    }
)[];
export type PageChooserBlockOrNull = null | PageChooserBlock;
export type BooleanBlockOrNull = null | BooleanBlock;
export type BooleanBlock = boolean;
export type TrackingPageCategory = (
  | {
      type: "link";
      value: LinkBlock;
      id: string;
    }
  | {
      type: "children";
      value: {
        type: "link";
        value: LinkBlock;
        id: string;
      }[];
      id: string;
    }
)[];
export type TrackingPageSidebar = {
  type: "category";
  value: TrackingPageCategory;
  id: string;
}[];

export interface _Types {
  BasePageTemplateProps: ThelabuiModelsPagesBasePageBasePageTemplate;
  BaseFormPageTemplateProps: ThelabuiModelsPagesBaseFormPageBaseFormPageTemplate;
  BaseFormPageLandingPageTemplateProps: ThelabuiModelsPagesBaseFormPageBaseFormPageLandingPageTemplate;
  ExamplePageTemplateProps: ThelabuiModelsPagesExamplePageExamplePageTemplate;
  LabUIToolboxSnippetPreviewProps: ThelabuiModelsSnippetsToolboxSnippetLabUIToolboxSnippetPreview;
  CheckoutHeaderTemplateProps: ServerCmsTemplatesCheckoutHeaderTemplate;
  RichNavigationTemplateProps: TsicommonCmsTemplatesRichNavigationTemplate;
  FlairSubBlockTemplateProps: TsicommonCmsTemplatesFlairSubBlockTemplate;
  DynamicPriceTemplateProps: TsicommonCmsTemplatesDynamicPriceTemplate;
  TrackShipmentDetailsTemplateProps: TsicommonCmsTemplatesTrackShipmentDetailsTemplate;
  globals: {
    Widget: generated.Types["Widget"];
    models: {};
  };
  Context: ReactivatedSerializationContextProcessorsBaseContext &
    ReactivatedSerializationContextProcessorsCSRFProcessor &
    ReactivatedSerializationContextProcessorsRequestProcessor &
    ReactivatedSerializationContextProcessorsStaticProcessor &
    ThelabuiContextProcessorsTranslationProcessor;
  RPCPermission: null;
}
export interface ThelabuiModelsPagesBasePageBasePageTemplate {
  is_preview: boolean;
  page: BasePageEb66F00405;
}
export interface BasePageEb66F00405 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
}
export interface ThelabuiTypesLanguage {
  code: string;
  vernacular_name: string;
  translated_name: string;
  dir: "ltr" | "rtl" | "auto";
}
export interface ThelabuiTypesAlternatePage {
  title: string;
  url: string;
  language: ThelabuiTypesLanguage;
}
export interface ThelabuiModelsPagesBaseFormPageBaseFormPageTemplate {
  is_preview: boolean;
  page: BaseFormPageFe4F84D43A;
  form: DjangoFormsForms;
}
export interface BaseFormPageFe4F84D43A {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
}
export interface DjangoFormsForms {
  name: "django.forms.forms.Form";
  errors: {} | null;
  fields: {};
  prefix: string;
  iterator: [];
  hidden_fields?: [];
}
export interface ThelabuiModelsPagesBaseFormPageBaseFormPageLandingPageTemplate {
  is_preview: boolean;
  page: BaseFormPageFe4F84D43A;
}
export interface ThelabuiModelsPagesExamplePageExamplePageTemplate {
  is_preview: boolean;
  page: ExamplePage_8C9639Cb8F;
}
export interface ExamplePage_8C9639Cb8F {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
  image: {
    block: ThelabuiSerializationImagesImageBlockValue;
  } | null;
  image_tile: {
    renditions_webp: WagtailImageRendition[];
  } | null;
  richtext: RichTextField;
  body: ThelabuiExamplePage;
  snippets: {
    body: ThelabuiLabUIToolboxSnippet;
  }[];
  attachment: {
    title: string;
    created_at: string;
    file_size: number | null;
    file_hash: string;
    filename: string;
    file_extension: string;
    url: string;
    content_type: string;
    content_disposition: string;
    file: FileField;
    tags: {
      name: string;
    }[];
  } | null;
}
export interface ThelabuiSerializationImagesImageBlockValue {
  title: string;
  width: number;
  height: number;
  brightness: number;
  url: string;
  renditions: {
    [k: string]: ThelabuiSerializationImagesImageRenditionBlockValue;
  };
}
export interface ThelabuiSerializationImagesImageRenditionBlockValue {
  spec: string;
  width: number;
  height: number;
  url: string;
  size: number;
  mimetype: string;
}
export interface WagtailImageRendition {
  spec: string;
  width: number;
  height: number;
  url: string;
  size: number;
  mimetype: string;
}
export interface RichTextField {
  _type: "RichTextField";
  html: string;
}
export interface ThelabuiExamplePage {
  _type: "StreamField";
  _variant: "thelabui.ExamplePage.body";
  value: LabUIToolbox;
  [k: string]: unknown;
}
export interface AlignedRichTextBlock {
  container?: ContainerSizeSubBlockOrNull;
  content?: AlignedRichTextSubBlockOrNull;
}
export interface ContainerSizeSubBlock {
  width?: null | ("" | "full" | "twoThirds" | "half");
}
export interface AlignedRichTextSubBlock {
  content?: RichTextBlockOrNull;
  alignment?: null | ("" | "textAlignCenter" | "textAlignRight");
}
export interface GallerySubBlock {
  slides?: _SlideListOrNull;
}
export interface _Slide {
  image: ImageChooserBlockOrNull;
  caption?: AlignedRichTextSubBlockOrNull;
}
export interface ImageChooserBlock {
  title: string;
  width: number;
  height: number;
  brightness: number;
  url: string;
  renditions: {
    /**
     * This interface was referenced by `undefined`'s JSON-Schema definition
     * via the `patternProperty` "^.*$".
     */
    [k: string]: {
      spec: string;
      width: number;
      height: number;
      url: string;
      size: number;
      mimetype: string;
    };
  };
}
export interface LinkSubBlock {
  display_name?: CharBlockOrNull;
  link_type?: null | ("page" | "external" | "email" | "document");
  anchor?: CharBlockOrNull;
  link_style?: null | ("" | "secondary" | "text-link");
  url: null | string;
}
export interface VideoChooserBlock {
  poster: null | string;
  sources: {
    url: string;
    mimetype: string;
  }[];
  title: string;
  tracks: {
    kind: string;
    kind_name: string;
    src: string;
    label: string;
    srclang: string;
    srclang_name: null | string;
    sort_order: number;
  }[];
  width: null | number;
  height: null | number;
  aspectRatio: null | number;
}
export interface MediaEmbedBlock {
  title: CharBlockOrNull;
  thumbnail: ImageChooserBlockOrNull;
  embed: EmbedBlockOrNull;
}
export interface ScrollNavMenuBlock {}
export interface ScrollNavMenuItemBlock {
  name: CharBlockOrNull;
}
export interface SocialMediaIcon {
  icon: null | ("facebook" | "instagram" | "linkedin" | "pinterest" | "tiktok" | "twitter" | "youtube");
  link: URLBlockOrNull;
}
export interface SpacerBlock {
  anchor?: CharBlockOrNull;
  height: null | ("no-height" | "small" | "medium" | "large" | "xlarge" | "xxlarge");
}
export interface TableInContainerBlock {
  container?: ContainerSizeSubBlockOrNull;
  table: TableBlockOrNull;
}
export interface OneTrustPrivacyNoticeBlock {
  script_url: URLBlockOrNull;
  callback_url: URLBlockOrNull;
  notice_url: URLBlockOrNull;
}
export interface ThelabuiLabUIToolboxSnippet {
  _type: "StreamField";
  _variant: "thelabui.LabUIToolboxSnippet.body";
  value: LabUIToolbox;
  [k: string]: unknown;
}
export interface FileField {
  url: string;
}
export interface ThelabuiModelsSnippetsToolboxSnippetLabUIToolboxSnippetPreview {
  object: LabUIToolboxSnippetFdc2906E1B;
}
export interface LabUIToolboxSnippetFdc2906E1B {
  id: number;
  name: string;
  body: ThelabuiLabUIToolboxSnippet;
}
export interface ServerCmsTemplatesCheckoutHeaderTemplate {
  app_slug: string;
  root_page_url: string;
  encoded_basket_id: string;
  support_website_phone_number: string;
}
export interface TsicommonCmsTemplatesRichNavigationTemplate {
  rich_navigation: RichNavigationC5Fd9Ac9C3 | null;
}
export interface RichNavigationC5Fd9Ac9C3 {
  name: string;
  content: TsicommonCmsRichNavigation | null;
  banner_content: TsicommonCmsRichNavigation1 | null;
  value_props: {
    value_prop: {
      title: RichTextField;
      icon: {
        block: ThelabuiSerializationImagesImageBlockValue1;
      } | null;
    };
    link: {
      url: string;
    } | null;
  }[];
}
export interface TsicommonCmsRichNavigation {
  _type: "StreamField";
  _variant: "tsicommon_cms.RichNavigation.content";
  value: RichNavigationContentAssembly;
  [k: string]: unknown;
}
export interface RichNavigationLinkCollection {
  name: CharBlockOrNull;
  collection_name_style?: CollectionNameStylesSubBlockOrNull;
  variant?:
    | null
    | (
        | ""
        | "rich-navigation--link-collection--two-thirds-link"
        | "rich-navigation--link-collection--single-column"
        | "rich-navigation--link-collection--heart"
        | "rich-navigation--link-collection--no-title"
        | "rich-navigation--link-collection--inspiration"
      );
  links?: TsicommonCmsRichNavigationLinkListOrNull;
  cta_link?: TsicommonCmsLinkOrNull;
  cta_text?: CharBlockOrNull;
  promo_features?: RichNavigationPromoFeaturesAssemblyOrNull;
}
export interface CollectionNameStylesSubBlock {
  style?: null | "";
}
export interface TsicommonCms1 {
  value: RichNavigationLinkTypes;
}
export interface _RichNavigation__GeneralLink {
  promo_period?: TsicommonCmsPromoPeriodOrNull;
  destination: TsicommonCmsLinkOrNull;
  text: RichTextBlockOrNull;
  flair?: FlairSubBlockOrNull;
  image: ImageChooserBlockOrNull;
}
export interface TsicommonCms2 {
  is_promo_active?: boolean;
}
export interface TsicommonCms3 {
  id: number;
  title: string;
  url: string;
}
export interface FlairSubBlock {
  style?:
    | null
    | (
        | ""
        | "flair--breeze"
        | "flair--lightning-bolt"
        | "flair--razzmatazz-angle"
        | "flair--razzmatazz"
        | "flair--razzmatazz-pill"
        | "flair--razzmatazz-pill-small-txt"
        | "flair--light-pink-pill-small-txt"
        | "flair--underline"
        | "flair--wifi"
        | "flair--adapt"
        | "flair--black-pill"
      );
  content?: RichTextBlockOrNull;
}
export interface _RichNavigation__OfferLink {
  promo_period?: TsicommonCmsPromoPeriodOrNull;
  offer: TsicommonCmsLinkOrNull;
  image: ImageChooserBlockOrNull;
  text: RichTextBlockOrNull;
  flair?: FlairSubBlockOrNull;
}
export interface _RichNavigation__ProductLink {
  promo_period?: TsicommonCmsPromoPeriodOrNull;
  destination: TsicommonCmsLinkOrNull;
  text: RichTextBlockOrNull;
  flair?: FlairSubBlockOrNull;
  image: ImageChooserBlockOrNull;
  subtitle?: RichTextBlockOrNull;
  callout?: RichTextBlockOrNull;
  promo_bubble?: _PromoBubbleOrNull;
}
export interface _PromoBubble {
  text?: CharBlockOrNull;
  image?: ImageChooserBlockOrNull;
}
export interface _RichNavigation__DynamicProductLink {
  promo_period?: TsicommonCmsPromoPeriodOrNull;
  destination: TsicommonCmsLinkOrNull;
  text: RichTextBlockOrNull;
  flair?: FlairSubBlockOrNull;
  image: ImageChooserBlockOrNull;
  title?: RichTextBlockOrNull;
  secondary_flair?: FlairSubBlockOrNull;
  product: ProductChooserSubBlockOrNull;
  price?: {
    currency: string | null;
    excl_tax: string | null;
    incl_tax: string | null;
    tax: string | null;
    retail?: string | null;
    cosmetic_excl_tax?: string | null;
    cosmetic_incl_tax?: string | null;
    enable_per_month_pricing?: boolean;
    per_month?: string | null;
    per_month_term_length?: number | null;
    post_discount_addons?: {
      name: string;
      price_excl_tax: string;
    }[];
  };
}
export interface _RichNavigation__ImageLink {
  promo_period?: TsicommonCmsPromoPeriodOrNull;
  destination: TsicommonCmsLinkOrNull;
  text: RichTextBlockOrNull;
  image: ImageChooserBlockOrNull;
}
export interface _RichNavigation__ButtonLink {
  promo_period?: TsicommonCmsPromoPeriodOrNull;
  destination: TsicommonCmsLinkOrNull;
  text: RichTextBlockOrNull;
}
export interface _RichNavigation__BannerLink {
  promo_period?: TsicommonCmsPromoPeriodOrNull;
  destination: TsicommonCmsLinkOrNull;
  text: RichTextBlockOrNull;
  flair?: FlairSubBlockOrNull;
}
export interface RichNavigationImagePromo {
  promo_period?: TsicommonCmsPromoPeriodOrNull;
  link?: TsicommonCmsLinkOrNull;
  image: ImageChooserBlockOrNull;
}
export interface CurrentStoreSection {}
export interface TsicommonCmsRichNavigation1 {
  _type: "StreamField";
  _variant: "tsicommon_cms.RichNavigation.banner_content";
  value: RichNavigationBannerContentAssembly;
  [k: string]: unknown;
}
export interface BannerBlock {
  responsive_visibility?: ResponsiveVisibilitySubBlockOrNull;
  spacing?: SpacingSubBlockOrNull;
  background_style?: BackgroundStylesSubBlockOrNull;
  content: RichTextBlockOrNull;
}
export interface ResponsiveVisibilitySubBlock {
  visibility?:
    | null
    | (
        | ""
        | "responsive-visibility--small-only"
        | "responsive-visibility--medium-only"
        | "responsive-visibility--medium-and-smaller"
        | "responsive-visibility--medium-and-larger"
        | "responsive-visibility--large-only"
      );
}
export interface SpacingSubBlock {
  top_spacing?:
    | null
    | ("" | "spacing--xtra-small" | "spacing--small" | "spacing--medium" | "spacing--large" | "spacing--xtra-large");
  top_inner_spacing?:
    | null
    | ("" | "spacing--xtra-small" | "spacing--small" | "spacing--medium" | "spacing--large" | "spacing--xtra-large");
  bottom_spacing?:
    | null
    | ("" | "spacing--xtra-small" | "spacing--small" | "spacing--medium" | "spacing--large" | "spacing--xtra-large");
  bottom_inner_spacing?:
    | null
    | ("" | "spacing--xtra-small" | "spacing--small" | "spacing--medium" | "spacing--large" | "spacing--xtra-large");
}
export interface BackgroundStylesSubBlock {
  style?:
    | null
    | (
        | ""
        | "background--image-full"
        | "background--image-full-height"
        | "background--image-pattern"
        | "background--alabaster"
        | "background--alabaster2"
        | "background--black"
        | "background--breeze-blue"
        | "background--blue-lp-gradient"
        | "background--limed-spruce"
        | "background--dark-grey"
        | "background--blue"
        | "background--navy"
        | "background--razzmatazz"
        | "background--white-to-black-radial"
        | "background--white-to-breeze-blue-radial"
        | "background--orient"
        | "background--st-tropaz"
        | "background--st-tropaz-pixel"
        | "background--st-tropaz-gradient"
        | "background--adapt-aqua"
        | "background--adapt-emerald"
        | "background--black-to-adapt-emerald-radial"
      );
  background_image?: ImageChooserBlockOrNull;
  background_image_shift?: BackgroundImageShiftSubBlockOrNull;
}
export interface BackgroundImageShiftSubBlock {
  shift_amount_x?: IntegerBlockOrNull;
}
export interface ThelabuiSerializationImagesImageBlockValue1 {
  title: string;
  width: number;
  height: number;
  brightness: number;
  url: string;
  renditions: {
    [k: string]: ThelabuiSerializationImagesImageRenditionBlockValue;
  };
}
export interface TsicommonCmsTemplatesFlairSubBlockTemplate {
  style: string;
  content: string;
}
export interface TsicommonCmsTemplatesDynamicPriceTemplate {
  product: string;
}
export interface TsicommonCmsTemplatesTrackShipmentDetailsTemplate {
  closest_step: string;
  config: OrderPipelineConfig_6Ffa86Bb12 | null;
  order_number: string;
  war_link: string;
  shipping_event: ShippingEvent_351390F8D2;
  shipping_address: ShippingAddressF8Cef04Cbb;
  lines: ShippingEventQuantityFad9477A49[];
  timestamps: {
    [k: string]: string;
  };
  delivery_date: string | null;
}
export interface OrderPipelineConfig_6Ffa86Bb12 {
  freight_delivery_steps: OrderOrderPipelineConfig | null;
  tracking_page_sidebar: OrderOrderPipelineConfig1 | null;
}
export interface OrderOrderPipelineConfig {
  _type: "StreamField";
  _variant: "order.OrderPipelineConfig.freight_delivery_steps";
  value: FreightDeliverySteps;
  [k: string]: unknown;
}
export interface OrderConfirmed {
  tracking_step_title: CharBlockOrNull;
  tracking_step_copy?: CharBlockOrNull;
  tracker_step: null | "Pending";
}
export interface OrderProcessing {
  tracking_step_title: CharBlockOrNull;
  tracking_step_copy?: CharBlockOrNull;
  tracker_step: null | "Order Processing";
}
export interface OrderPreparedForShipment {
  tracking_step_title: CharBlockOrNull;
  tracking_step_copy?: CharBlockOrNull;
  tracker_step: null | "Order Prepared for Shipment";
}
export interface OrderShipped {
  tracking_step_title: CharBlockOrNull;
  tracking_step_copy?: CharBlockOrNull;
  tracker_step: null | "Shipped";
}
export interface ReadyForDelivery {
  tracking_step_title: CharBlockOrNull;
  tracking_step_copy?: CharBlockOrNull;
  tracker_step: null | "Arrived at Local Carrier";
}
export interface DeliveryScheduled {
  tracking_step_title: CharBlockOrNull;
  tracking_step_copy?: CharBlockOrNull;
  tracker_step: null | "Delivery Scheduled";
}
export interface OutForDelivery {
  tracking_step_title: CharBlockOrNull;
  tracking_step_copy?: CharBlockOrNull;
  tracker_step: null | "Out for Delivery";
}
export interface Delivered {
  tracking_step_title: CharBlockOrNull;
  tracking_step_copy?: CharBlockOrNull;
  tracker_step: null | "Delivered";
}
export interface OrderOrderPipelineConfig1 {
  _type: "StreamField";
  _variant: "order.OrderPipelineConfig.tracking_page_sidebar";
  value: TrackingPageSidebar;
  [k: string]: unknown;
}
export interface LinkBlock {
  display_name: CharBlockOrNull;
  page?: PageChooserBlockOrNull;
  external_url?: CharBlockOrNull;
  is_button?: BooleanBlockOrNull;
}
export interface PageChooserBlock {
  id: number;
  url: string;
  title: string;
}
export interface ShippingEvent_351390F8D2 {
  tracking_number: string | null;
  tracking_url: string | null;
}
export interface ShippingAddressF8Cef04Cbb {
  line1: string;
  line2: string;
  line3: string;
  line4: string;
  state: string;
  postcode: string;
  country: {
    printable_name: string;
  };
  phone_number: string;
}
export interface ShippingEventQuantityFad9477A49 {
  line: {
    product_link: string | null;
    product_image: string | null;
    product_title: string;
    product: {
      attribute_summary: string;
    } | null;
    line_price_before_discounts_excl_tax: string;
    post_discount_addon_total_excl_tax_as_str: string;
    line_price_excl_tax: string;
  };
  quantity: number;
}
export interface ReactivatedSerializationContextProcessorsBaseContext {
  template_name: string;
}
export interface ReactivatedSerializationContextProcessorsCSRFProcessor {
  csrf_token: string;
}
export interface ReactivatedSerializationContextProcessorsRequestProcessor {
  request: ReactivatedSerializationContextProcessorsRequest;
}
export interface ReactivatedSerializationContextProcessorsRequest {
  path: string;
  url: string;
  csp_nonce: string | null;
}
export interface ReactivatedSerializationContextProcessorsStaticProcessor {
  STATIC_URL: string;
}
export interface ThelabuiContextProcessorsTranslationProcessor {
  i18n: ThelabuiContextProcessorsTranslationCatalog;
}
export interface ThelabuiContextProcessorsTranslationCatalog {
  language: ThelabuiTypesLanguage;
  catalog: ThelabuiContextProcessorsCatalogEntry[];
  formats: ThelabuiContextProcessorsFormatEntry[];
}
export interface ThelabuiContextProcessorsCatalogEntry {
  key: string;
  value: string;
}
export interface ThelabuiContextProcessorsFormatEntry {
  key: string;
  value: string | number | string[];
}
export class RPC {
    constructor(public requester: rpcUtils.Requester) {
    }
}
export type UUID = `${string}-${string}-${string}-${string}-${string}`;

import type {Renderer as GenericRenderer} from "reactivated/dist/render.mjs";
export type Renderer = GenericRenderer<_Types["Context"]>;

export const rpc = new RPC(typeof window != "undefined" ? rpcUtils.defaultRequester : null as any);
import React from "react"
import * as generated from "reactivated/dist/generated";
import * as rpcUtils from "reactivated/dist/rpc";
import {constants} from "./constants";
export {constants};

export function classNames(...classes: (string | undefined | null | false)[]) {
    return classes.filter(Boolean).join(" ");
}

// Note: this needs strict function types to behave correctly with excess properties etc.
export type Checker<P, U extends (React.FunctionComponent<P> | React.ComponentClass<P>)> = {};

export type Result<TSuccess, TInvalid> = rpcUtils.Result<TSuccess, TInvalid, _Types["RPCPermission"]>;

export {Context} from "./context";
import {Context} from "./context";

import * as forms from "reactivated/dist/forms";
export type {FormHandler} from "reactivated/dist/forms";
export {reverse} from "./urls";

export const Provider = (props: {value: _Types["Context"]; children: React.ReactNode}) => {
    const [value, setValue] = React.useState(props.value);

    return (
        <Context.Provider value={{...value, setValue}}>
            {props.children}
        </Context.Provider>
    );
};

export const getServerData = () => {
    const props: Record<string, unknown> = (window as any).__PRELOADED_PROPS__;
    const context: _Types["Context"] = (window as any).__PRELOADED_CONTEXT__;

    return {props, context};
};

export type models = _Types["globals"]["models"];

export type {FieldHandler} from "./forms";
export {Form, FormSet, Widget, useForm, useFormSet, ManagementForm} from "reactivated/dist/forms";


import {Template as BasePageTemplateImplementation} from "@client/templates/BasePageTemplate"
export type BasePageTemplateCheck = Checker<_Types["BasePageTemplateProps"], typeof BasePageTemplateImplementation>;

export namespace templates {
    export type BasePageTemplate = _Types["BasePageTemplateProps"];
}


        



import {Template as BaseFormPageTemplateImplementation} from "@client/templates/BaseFormPageTemplate"
export type BaseFormPageTemplateCheck = Checker<_Types["BaseFormPageTemplateProps"], typeof BaseFormPageTemplateImplementation>;

export namespace templates {
    export type BaseFormPageTemplate = _Types["BaseFormPageTemplateProps"];
}


        



import {Template as BaseFormPageLandingPageTemplateImplementation} from "@client/templates/BaseFormPageLandingPageTemplate"
export type BaseFormPageLandingPageTemplateCheck = Checker<_Types["BaseFormPageLandingPageTemplateProps"], typeof BaseFormPageLandingPageTemplateImplementation>;

export namespace templates {
    export type BaseFormPageLandingPageTemplate = _Types["BaseFormPageLandingPageTemplateProps"];
}


        



import {Template as ExamplePageTemplateImplementation} from "@client/templates/ExamplePageTemplate"
export type ExamplePageTemplateCheck = Checker<_Types["ExamplePageTemplateProps"], typeof ExamplePageTemplateImplementation>;

export namespace templates {
    export type ExamplePageTemplate = _Types["ExamplePageTemplateProps"];
}


        



import {Template as LabUIToolboxSnippetPreviewImplementation} from "@client/templates/LabUIToolboxSnippetPreview"
export type LabUIToolboxSnippetPreviewCheck = Checker<_Types["LabUIToolboxSnippetPreviewProps"], typeof LabUIToolboxSnippetPreviewImplementation>;

export namespace templates {
    export type LabUIToolboxSnippetPreview = _Types["LabUIToolboxSnippetPreviewProps"];
}


        



import {Template as CheckoutHeaderTemplateImplementation} from "@client/templates/CheckoutHeaderTemplate"
export type CheckoutHeaderTemplateCheck = Checker<_Types["CheckoutHeaderTemplateProps"], typeof CheckoutHeaderTemplateImplementation>;

export namespace templates {
    export type CheckoutHeaderTemplate = _Types["CheckoutHeaderTemplateProps"];
}


        



import {Template as RichNavigationTemplateImplementation} from "@client/templates/RichNavigationTemplate"
export type RichNavigationTemplateCheck = Checker<_Types["RichNavigationTemplateProps"], typeof RichNavigationTemplateImplementation>;

export namespace templates {
    export type RichNavigationTemplate = _Types["RichNavigationTemplateProps"];
}


        



import {Template as FlairSubBlockTemplateImplementation} from "@client/templates/FlairSubBlockTemplate"
export type FlairSubBlockTemplateCheck = Checker<_Types["FlairSubBlockTemplateProps"], typeof FlairSubBlockTemplateImplementation>;

export namespace templates {
    export type FlairSubBlockTemplate = _Types["FlairSubBlockTemplateProps"];
}


        



import {Template as DynamicPriceTemplateImplementation} from "@client/templates/DynamicPriceTemplate"
export type DynamicPriceTemplateCheck = Checker<_Types["DynamicPriceTemplateProps"], typeof DynamicPriceTemplateImplementation>;

export namespace templates {
    export type DynamicPriceTemplate = _Types["DynamicPriceTemplateProps"];
}


        



import {Template as TrackShipmentDetailsTemplateImplementation} from "@client/templates/TrackShipmentDetailsTemplate"
export type TrackShipmentDetailsTemplateCheck = Checker<_Types["TrackShipmentDetailsTemplateProps"], typeof TrackShipmentDetailsTemplateImplementation>;

export namespace templates {
    export type TrackShipmentDetailsTemplate = _Types["TrackShipmentDetailsTemplateProps"];
}


        
export {Iterator, CSRFToken, createRenderer} from "./forms";
export {getTemplate} from "./template";

